import React, {useContext, useEffect, useState} from "react";
import {IStepQuiz} from "../../../interfaces/IStepQuiz";
import {CardActionArea} from "@material-ui/core";
import {makeStyles, withStyles} from "@material-ui/core/styles";
import Divider from "@material-ui/core/Divider";
import Colors from "../../../styles/colors";
import Box from "@material-ui/core/Box";
import Slider from "@material-ui/core/Slider";
import {AppContext} from "../../../App";
import {AppService} from "../../../services/app.service";
import {faThumbsDown, faThumbsUp} from "@fortawesome/pro-light-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import QuizHeader from "./QuizHeader";

const useStyles = makeStyles((theme) => ({
    mainContainer: {
        width: '100%',
        overflowY: "scroll",
        height: window.innerHeight,
    },
    answerParent: {
        paddingLeft: 30,
        paddingRight: 24,
        paddingTop: 20,
    },
    actionArea: {
        paddingLeft: 24,
        paddingRight: 24,
    },
    buttonStep: {
        width: '100%',
        borderRadius: 5,
        backgroundColor: Colors.primary,
        opacity: 5,
        height: 56,
        color: "white",
        fontFamily: [
            'LotaGrotesque',
        ].join(','),
        fontWeight: "bold",
        textTransform: "none",
        letterSpacing: 0.25,
        fontSize: 18,
        fontStretch: "normal",
        textAlign: "center",
    },
    disabledButtonStep: {
        width: '100%',
        borderRadius: 5,
        backgroundColor: Colors.light,
        opacity: 5,
        height: 56,
        color: "white",
        fontFamily: [
            'LotaGrotesque',
        ].join(','),
        fontWeight: "bold",
        textTransform: "none",
        letterSpacing: 0.25,
        fontSize: 18,
        fontStretch: "normal",
        textAlign: "center",
    },
    filler: {
        paddingBottom: 200,
    },
    sliderParent: {
        display: "flex",
        paddingLeft: 20,
        paddingRight: 20,
        flexWrap: "wrap"
    },
    sliderQuestion: {
        fontFamily: [
            'LotaGrotesque',
        ].join(','),
        fontWeight: "bold",
        letterSpacing: "normal",
        fontSize: 20,
        lineHeight: 1.3,
        color: Colors.lessDark,
        paddingTop: 12,
    },
    sliderControl: {
        width: '100%'
    },
    slideControlThumbsDown:{
        flexGrow: 1,
    },
    sliderSlideControl: {
        flexGrow: 4,
    },
    slideControlThumbsUp:{
        flexGrow: 1,
    },
    thumbs: {
        fontSize: 20,
        color: Colors.primary,
    },
    sliderLabel:{
        fontFamily: [
            'LotaGrotesque',
        ].join(','),
        fontWeight: "normal",
        fontSize: 13,
    },
}));

const PrettoSlider = withStyles({
    root: {
        color: Colors.light,
        height: 8,
    },
    thumb: {
        height: 24,
        width: 24,
        backgroundColor: '#fff',
        border: '2px solid',
        borderColor: Colors.primary,
        marginTop: -8,
        marginLeft: -12,
        '&:focus, &:hover, &$active': {
            boxShadow: 'inherit',
        },
    },
    active: {},
    valueLabel: {
        left: 'calc(-50% + 4px)',
    },
    track: {
        height: 6,
        borderRadius: 4,
        background: '#ccc',
        opacity: 0.2,
    },
    rail: {
        height: 6,
        borderRadius: 4,
        background: '#ccc',
    },
})(Slider);

interface ISurveyResultDictionary {
    [key: string]: number
}

interface ISupportingContent{
    [key: string]: any
}

function SurveyType(props: IStepQuiz){
    const classes = useStyles();
    let questionConfig: any = props.questionConfig;
    let surveys:any = [];
    let surveyItems: any = Object.values(questionConfig)[0]
    const context = useContext(AppContext);

    const [canProceed, setCanProceed] = useState<Boolean>(false);
    const [surveyResponse, setSurveyResponse] = useState<ISurveyResultDictionary>({});
    const [surveyResult, setSurveyResult] = useState<ISurveyResultDictionary>({});

    const [surveyDataIsLoaded, setSurveyDataIsLoaded] = useState<boolean>(false)

    function collectSurvey(inputId: string, score: number)
    {
        let survResp: any = surveyResponse;
        survResp[`${inputId}`] = score;
        setSurveyResponse(survResp)

        // Ensures that user touches all slider to proceed.
        // count number of Response
        let numberOfAnsweredSurveys: number = 0;
        Object.entries(survResp).forEach(
            ([key, value]) => {
                numberOfAnsweredSurveys++;
            }
        );

        if(numberOfAnsweredSurveys === surveyItems.length){
            getSurveyResult(survResp)
            setCanProceed(true);
        } else {
            setCanProceed(false);
        }

        console.log(surveyResponse);
    }

    // surveys have different approach of result depending on steps
    function getSurveyResult(surveyData: any) : any {

        if(Number(context.currentWeekNo) === 1 &&
            Number(context.currentTaskNo) === 11 &&
            Number(context.currentStepNo) === 2) {

            // Do logic of that survey here.
            // For this screen we will get average
            let result: any = {};
            let totalPoints: number = 0;

            Object.entries(surveyData).forEach(
                ([key, value]) => {
                    if(key.split('-')[0] === 'revslider') {
                        totalPoints += (100 - Number(value));
                    } else {
                        totalPoints +=  Number(value);
                    }
                }
            );
            let resultAverage: number = totalPoints / surveyItems.length;

            let mindset: string = "";
            if(resultAverage <= 50){
                mindset = "negative";
            } else if(resultAverage <=80) {
                mindset = "cautious"
            } else if(resultAverage <= 100) {
                mindset = "growth"
            }

            result['mindset'] = mindset;
            result['average'] = resultAverage;

            console.log(surveyResult)
            context.setSurveyResult(result);
            setSurveyResult(result)
            return surveyResult;
        }


        if(Number(context.currentWeekNo) === 4 &&
            Number(context.currentTaskNo) === 6 &&
            Number(context.currentStepNo) === 1) {

            // Do logic of that survey here.
            // For this screen we will get average

            let result: any = {};
            let totalPoints: number = 0;

            Object.entries(surveyData).forEach(
                ([key, value]) => {
                    if(key.split('-')[0] === 'revslider') {
                        totalPoints += (100 - Number(value)) / 10;
                    } else {
                        totalPoints +=  Number(value) / 10;
                    }
                }
            );

            let resultAverage: number = totalPoints / surveyItems.length;
            result['average'] = resultAverage;

            if (resultAverage >= 7) {
                result['translatedResult']  = "High Fear"
            } else if (resultAverage >= 3) {
                result['translatedResult']  = "Moderate Fear"
            }else {
                result['translatedResult']  = "Low Fear"
            }

            console.log(surveyResult)
            context.setSurveyResult(result);
            setSurveyResult(result)
            return surveyResult;
        }

        if((Number(context.currentWeekNo) === 2 &&
            Number(context.currentTaskNo) === 9 &&
            Number(context.currentStepNo) === 1) ||
            (Number(context.currentWeekNo) === 2 &&
            Number(context.currentTaskNo) === 9 &&
            Number(context.currentStepNo) === 3)) {

            let result: any = {};
            let highest: number = 0;
            // for this screen we will get the highest rank
            Object.entries(surveyData).forEach(
                ([key, value]) => {
                    if(Number(value) >= highest){
                        let indexValue: number = Number(key.split('-')[1]);
                        highest = Number(value);
                        result["highestRank"] = surveyItems[indexValue].question;
                    }
                }
            );
            context.setSurveyResult(result);
            setSurveyResult(result)
            return surveyResult;
        }

        return "";
    }

    for(let i = 0; i < surveyItems.length; i++){
        let sliderId: string =  `${(surveyItems[i].reversed)?'rev':''}slider-${i}`
        surveys.push(
            <div key={i}>
                <div className={classes.sliderParent}>
                    <div className={classes.sliderQuestion}>{surveyItems[i].question}</div>
                    <div className={classes.sliderControl}>
                        <Box display="flex" alignItems="center">
                            <Box width="10%">
                                <FontAwesomeIcon icon={faThumbsDown} className={classes.thumbs}/>
                            </Box>
                            <Box width="80%" mr={2}>
                                <PrettoSlider
                                    key={`${context.currentWeekNo}${context.currentTaskNo}${context.currentStepNo}${sliderId}`}
                                    id={sliderId}
                                    marks = {false}
                                    step={10}
                                    max={100}
                                    valueLabelDisplay="auto"
                                    aria-label="quiz-slider"
                                    defaultValue={50}
                                    value={(surveyResponse[sliderId] !== undefined) ? surveyResponse[sliderId] : 50 }
                                    onChange={(event, v) => {
                                        collectSurvey(sliderId, Number(v));
                                    }}
                                />
                            </Box>
                            <Box width="10%">
                                <FontAwesomeIcon icon={faThumbsUp} className={classes.thumbs}/>
                            </Box>
                        </Box>
                    </div>

                    <div className={classes.sliderControl}>
                        <Box display="flex" alignItems="center" className={classes.sliderLabel}>
                            <Box width="50%" style={{textAlign: "left"}}>
                                {surveyItems[i].lowestLabel}
                            </Box>
                            <Box width="50%"  style={{textAlign: "right"}}>
                                {surveyItems[i].highestLabel}
                            </Box>
                        </Box>
                    </div>
                </div>
                <br/>
                <Divider/>
                <br/>
            </div>
        )
    }

    function saveResponse(weekNo: number, taskNo: number, stepNo: number, response: any) {
        let appService = new AppService();
        let result = appService.saveQuizResponse(response, props.id, `${weekNo}${taskNo}${stepNo}`);
        console.log(result)
    }

    function handleAction() {
        if(canProceed) {
            console.log('saving response');
            // let finalSurveyData: ISupportingContent = surveyResponse;
            // finalSurveyData['result'] =  surveyResult;

            let content: ISupportingContent = {}
            content['sliderData'] = surveyResponse
            content['surveyResult'] = surveyResult

            console.log('content to send ==D', content)
            saveResponse(Number(context.currentWeekNo),
                Number(context.currentTaskNo),
                Number(context.currentStepNo), JSON.stringify(content));
            props.moveNext();
        }
    }

    useEffect(()=> {
        console.log("getting survey data!!!")
        async function getSurveyData(){

            //do this only if not yet loaded
            if(!surveyDataIsLoaded) {
                let appService = new AppService();
                const existing_response = await appService.getQuizResponse(props.id);
                console.log('response', existing_response.data.payload.saved_response);
                if(Object.keys(existing_response.data.payload.saved_response).length > 0){
                    let savedResponse = JSON.parse(existing_response.data.payload.saved_response);
                    // console.log('slider-data - ', savedResponse['sliderData'])
                    setSurveyResponse(savedResponse['sliderData'])
                } else {
                    //if no value lets initialize them
                    let initSurveyResp: any = surveyResponse;
                    for(let i = 0; i < surveyItems.length; i++){
                        let sliderId: string =  `${(surveyItems[i].reversed)?'rev':''}slider-${i}`
                        initSurveyResp[sliderId] = 50
                    }
                    console.log('init', initSurveyResp)
                    setSurveyResponse(initSurveyResp)
                }

                let numberOfAnsweredSurveys: number = 0;
                Object.entries(surveyResponse).forEach(
                    ([key, value]) => {
                        numberOfAnsweredSurveys++;
                    }
                );

                console.log('numberOfAnsweredSurveys', numberOfAnsweredSurveys);

                if(numberOfAnsweredSurveys === surveyItems.length){
                    getSurveyResult(surveyResponse)
                    setCanProceed(true);
                } else {
                    setCanProceed(false);
                }

                setSurveyDataIsLoaded(true);
            }

        }
        getSurveyData();

    }, [context]);

    useEffect(()=>{
        async function getSupportContent(){
            if(Number(context.currentWeekNo) === 4 &&
                Number(context.currentTaskNo) === 5 &&
                Number(context.currentStepNo) === 11) {
                console.log('get support content');
            }
        }
        getSupportContent();
    }, [context])

    return(
        <div className={'survey'}>
            <QuizHeader question={props.prompt} customLabel={'QUIZ'}/>
            <div className={'survey-container'}>
                {surveys}
            </div>
            <div className={'quiz-action-area'}>
                <CardActionArea className={'previous-button'} onClick={props.moveBack}>
                    Previous
                </CardActionArea>
                <CardActionArea className={(canProceed) ? 'transcript-button' : 'transcript-button-disabled'} onClick={handleAction}>
                    {(props.buttonLabel) ? props.buttonLabel : "Next"}
                </CardActionArea>
            </div>
            <div className={'mobile-spacing'}/>
        </div>

    )
}
export default SurveyType;